/**
 * Hand a downloaded file to the browser.
 *
 * Prefers the filename the server set in Content-Disposition, so the name is decided in one place
 * — the endpoint that built the file — rather than guessed again on the client.
 *
 * `src/LandlordModule/data.service.ts` has its own copy of this from the bank-details work. This
 * is the shared home for it; that one can move here when someone is next in that file.
 */
export function triggerBrowserDownload(blob: Blob, fallbackName: string, headers?: any): void {
  const disposition = headers && (headers['content-disposition'] || headers['Content-Disposition']);
  let filename = fallbackName;

  if (disposition) {
    const match = /filename="?([^";]+)"?/.exec(String(disposition));
    if (match && match[1]) {
      filename = match[1];
    }
  }

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
